import en from './en.translations.json.js';
import de from './de.translations.json.js';
import fr from './fr.translations.json.js';
import it from './it.translations.json.js';
import es from './es.translations.json.js';
import nl from './nl.translations.json.js';
import localizationSupportTranslationsEn from '../../mixins/localization-support/en.translations.json.js';
import localizationSupportTranslationsDe from '../../mixins/localization-support/de.translations.json.js';
import localizationSupportTranslationsFr from '../../mixins/localization-support/fr.translations.json.js';
import localizationSupportTranslationsIt from '../../mixins/localization-support/it.translations.json.js';
import localizationSupportTranslationsEs from '../../mixins/localization-support/es.translations.json.js';
import localizationSupportTranslationsNl from '../../mixins/localization-support/nl.translations.json.js';

const alertBadgeTranslationsDe = { ...de, ...localizationSupportTranslationsDe };
const alertBadgeTranslationsEn = { ...en, ...localizationSupportTranslationsEn };
const alertBadgeTranslationsEs = { ...es, ...localizationSupportTranslationsEs };
const alertBadgeTranslationsFr = { ...fr, ...localizationSupportTranslationsFr };
const alertBadgeTranslationsIt = { ...it, ...localizationSupportTranslationsIt };
const alertBadgeTranslationsNl = { ...nl, ...localizationSupportTranslationsNl };
const alertBadgeTranslationsBundle = {
  de: alertBadgeTranslationsDe,
  en: alertBadgeTranslationsEn,
  es: alertBadgeTranslationsEs,
  fr: alertBadgeTranslationsFr,
  it: alertBadgeTranslationsIt,
  nl: alertBadgeTranslationsNl
};

export { alertBadgeTranslationsBundle, alertBadgeTranslationsDe, alertBadgeTranslationsEn, alertBadgeTranslationsEs, alertBadgeTranslationsFr, alertBadgeTranslationsIt, alertBadgeTranslationsNl };
